'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHostName = getHostName;
exports.getParams = getParams;
exports.getReferrer = getReferrer;
exports.getLocation = getLocation;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getHostName(url) {
  if (!url) {
    return null;
  }

  return new _urlParse2.default(url).hostname;
}
/* eslint-disable prefer-destructuring */


function getParams(url) {
  if (!url) {
    return {};
  }

  return new _urlParse2.default(url, true).query;
}
/**
 * Returns the current referrer by inspecting the window object.
 * Based on Snowplow's `getReferrer` implementation:
 * https://github.com/snowplow/snowplow-javascript-tracker
 *
 * @param window {object}
 */


function getReferrer(window) {
  var _getParams = getParams(window.location.href),
      referrer = _getParams.referrer;

  if (referrer) {
    return referrer;
  }

  try {
    referrer = window.top.document.referrer;
  } catch (e) {
    try {
      referrer = window.parent.document.referrer;
    } catch (e2) {
      referrer = '';
    }
  }

  if (referrer == null || referrer === '') {
    referrer = window.document.referrer;
  }

  return referrer;
}
/**
 * Returns an object containing the "fixed" domain, href, and referrer.
 * Based on Snowplow's `fixupUrl` implementation:
 * https://github.com/snowplow/snowplow-javascript-tracker
 *
 * @param window {object}
 */


function getLocation(window) {
  var domain = window.document.domain;
  var href = window.location.href;
  var referrer = getReferrer(window);

  if (domain === 'translate.googleusercontent.com') {
    // Google Translate
    if (referrer === '') {
      referrer = href;
    }

    href = getParams(href).u;
    domain = getHostName(href);
  } else if (domain === 'cc.bingj.com' || // Bing
  domain === 'webcache.googleusercontent.com' || // Google
  domain && domain.slice(0, 5) === '74.6.') {
    // Yahoo (via Inktomi 74.6.0.0/16)
    href = window.document.links[0].href;
    domain = getHostName(href);
  }

  return {
    domain: domain,
    href: href,
    referrer: referrer
  };
}